// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home[data-v-770faeca],.home .aside[data-v-770faeca],.home .header[data-v-770faeca]{height:100%}.home .main[data-v-770faeca]{padding:0}.home .main .body[data-v-770faeca]{height:100%}.home .main .body .breadcrumb[data-v-770faeca]{line-height:40px}.home .main .body .views[data-v-770faeca]{background:#f0f0f0;padding:10px}", ""]);
// Exports
module.exports = exports;
